"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NeRiverTypes_exports = {};
__export(NeRiverTypes_exports, {
  NeRiverTypes: () => NeRiverTypes,
  proposedRiverTypesModificationsLayer: () => proposedRiverTypesModificationsLayer
});
module.exports = __toCommonJS(NeRiverTypes_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_core = require("../../core/index.js");
var import_NeChalkRivers = require("./NeChalkRivers.js");
var import_types = require("@cartographerio/types");
const predHabSizeMul = 0.5;
const predhabStrokeMul = 0.25;
const chalkRiversSizeMul = 0.75;
const chalkRiversStrokeMul = 0.25;
const nePredHabMapUkSource = (0, import_topo_map.remoteTileSource)({
  url: "mapbox://cartographerio.ne_pred_hab_map_uk",
  sourceLayer: "ne_pred_hab_map_uk",
  attribution: [
    (0, import_topo_map.standardAttribution)({
      what: "Predicted Habitat Map",
      who: "Natural England",
      from: "November 2022",
      url: "https://priorityhabitats.org"
    })
  ]
});
const featureBuckets = [(0, import_topo_map.lookupBucket)(true, import_topo_map.marker.hue(90), "Yes"), (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.empty, "No")];
const proposedRiverTypesModificationsLayer = (0, import_topo_map.lineLayer)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neRiverTypes"),
  title: "Proposed River Types",
  source: (0, import_core.cartographerSourceWithDefaults)({
    layerId: (0, import_topo_map.unsafeMapLayerId)("neRiverTypes"),
    simplifyZoom: 10,
    attribution: []
  }),
  attributes: [
    (0, import_topo_map.attributeGroup)({
      label: "Dominant Type",
      attributes: [
        (0, import_topo_map.enumAttr)({
          attributeId: `dominant`,
          label: "Dominant Type",
          enum: import_inventory_enums.NeRiverTypesFeatureEnum
        })
      ]
    }),
    (0, import_topo_map.attributeGroup)({
      label: "Applicable Types",
      attributes: import_inventory_enums.NeRiverTypesFeatureEnum.entries.flatMap(
        ({ value, label }) => (0, import_topo_map.booleanAttr)({
          attributeId: `selected_${value}`,
          label,
          buckets: featureBuckets
        })
      )
    }),
    (0, import_topo_map.attributeGroup)({
      label: "Confidence",
      attributes: import_inventory_enums.NeRiverTypesFeatureEnum.entries.flatMap(
        ({ value, label }) => (0, import_topo_map.enumAttr)({
          attributeId: `confidence_${value}`,
          label,
          enum: import_inventory_enums.NeRiverTypesConfidenceEnum
        })
      )
    })
  ]
});
const NeRiverTypes = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("neRiverTypes"),
  title: "River Types",
  defaultBase: import_types.MapBaseEnum.Satellite,
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("h3260"),
      title: "Habitats Directive H3260",
      source: nePredHabMapUkSource,
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "h3260_high",
              label: "High Certainty Only",
              propertyName: "h3260",
              buckets: [(0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#f7f", predHabSizeMul, predhabStrokeMul), "High")]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "h3260_all",
              label: "All Certainties",
              propertyName: "h3260",
              buckets: [
                (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#f7f", predHabSizeMul, predhabStrokeMul), "High"),
                (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.fromColor("#b5b", predHabSizeMul, predhabStrokeMul), "Medium"),
                (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#848", predHabSizeMul, predhabStrokeMul), "Low")
              ]
            })
          ]
        })
      ]
    }),
    (0, import_NeChalkRivers.publishedChalkRiversLayer)(
      (0, import_topo_map.unsafeMapLayerId)("chalkRivers"),
      "Chalk Rivers",
      import_topo_map.marker.fromColor("#ff0", chalkRiversSizeMul, chalkRiversStrokeMul),
      import_topo_map.marker.fromColor("#aa0", chalkRiversSizeMul, chalkRiversStrokeMul)
    ),
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("hw"),
      title: "Headwater Streams",
      source: nePredHabMapUkSource,
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "hw_high",
              label: "High Certainty Only",
              propertyName: "hw",
              buckets: [(0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#0ff", predHabSizeMul, predhabStrokeMul), "High")]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "hw_all",
              label: "All Certainties",
              propertyName: "hw",
              buckets: [
                (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#0ff", predHabSizeMul, predhabStrokeMul), "High"),
                (0, import_topo_map.lookupBucket)(0, import_topo_map.marker.fromColor("#0aa", predHabSizeMul, predhabStrokeMul), "Low")
              ]
            })
          ]
        })
      ]
    }),
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("pccrlsas"),
      title: "Active Shingle Rivers",
      source: nePredHabMapUkSource,
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlsas_high",
              label: "High Certainty Only",
              propertyName: "pccrlsas",
              buckets: [(0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#fff", predHabSizeMul, predhabStrokeMul), "High")]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlsas_all",
              label: "All Certainties",
              propertyName: "pccrlsas",
              buckets: [
                (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#fff", predHabSizeMul, predhabStrokeMul), "High"),
                (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.fromColor("#ccc", predHabSizeMul, predhabStrokeMul), "Medium"),
                (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#aaa", predHabSizeMul, predhabStrokeMul), "Low")
              ]
            })
          ]
        })
      ]
    }),
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("pccrlc22a"),
      title: "C2.2a High Energy",
      source: nePredHabMapUkSource,
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlc22a_high",
              label: "High Certainty Only",
              propertyName: "pccrlc22a",
              buckets: [(0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#f77", predHabSizeMul, predhabStrokeMul), "High")]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlc22a_all",
              label: "All Certainties",
              propertyName: "pccrlc22a",
              buckets: [
                (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#f77", predHabSizeMul, predhabStrokeMul), "High"),
                (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.fromColor("#b55", predHabSizeMul, predhabStrokeMul), "Medium"),
                (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#844", predHabSizeMul, predhabStrokeMul), "Low")
              ]
            })
          ]
        })
      ]
    }),
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("pccrlc22b"),
      title: "C2.2b Moderate Energy",
      source: nePredHabMapUkSource,
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlc22b_high",
              label: "High Certainty Only",
              propertyName: "pccrlc22b",
              buckets: [(0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#0f0", predHabSizeMul, predhabStrokeMul), "High")]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlc22b_all",
              label: "All Certainties",
              propertyName: "pccrlc22b",
              buckets: [
                (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#0f0", predHabSizeMul, predhabStrokeMul), "High"),
                (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.fromColor("#0b0", predHabSizeMul, predhabStrokeMul), "Medium"),
                (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#080", predHabSizeMul, predhabStrokeMul), "Low")
              ]
            })
          ]
        })
      ]
    }),
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("pccrlc23"),
      title: "C2.3 Low Energy",
      source: nePredHabMapUkSource,
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlc23_high",
              label: "High Certainty Only",
              propertyName: "pccrlc23",
              buckets: [(0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#77f", predHabSizeMul, predhabStrokeMul), "High")]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "pccrlc23_all",
              label: "All Certainties",
              propertyName: "pccrlc23",
              buckets: [
                (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.fromColor("#77f", predHabSizeMul, predhabStrokeMul), "High"),
                (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.fromColor("#55b", predHabSizeMul, predhabStrokeMul), "Medium"),
                (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#448", predHabSizeMul, predhabStrokeMul), "Low")
              ]
            })
          ]
        })
      ]
    }),
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("tidal"),
      title: "Tidally Influenced Rivers",
      source: nePredHabMapUkSource,
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "tidal",
              label: "Tidally Influenced Rivers",
              propertyName: "tidal",
              buckets: [
                (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.fromColor("#33f", predHabSizeMul, predhabStrokeMul), "Tidally Influenced")
              ]
            })
          ]
        })
      ]
    }),
    import_NeChalkRivers.proposedChalkRiversModificationsLayer,
    proposedRiverTypesModificationsLayer
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  NeRiverTypes,
  proposedRiverTypesModificationsLayer
});
//# sourceMappingURL=NeRiverTypes.js.map
